module.exports = __webpack_public_path__ + "img/组合项目.0c43e89e.png";